import { Prestador } from "../interfaces";

const inferirMimeTypeImagenBase64 = (imagenBase64 = "") => {
  if (typeof imagenBase64 !== "string") {
    return "image/jpeg";
  }

  const imagenNormalizada = imagenBase64.trim();

  if (imagenNormalizada.startsWith("/9j/")) return "image/jpeg";
  if (imagenNormalizada.startsWith("iVBORw0KGgo")) return "image/png";
  if (imagenNormalizada.startsWith("Qk")) return "image/bmp";
  if (imagenNormalizada.startsWith("UklGR")) return "image/webp";

  return "image/jpeg";
};

export const obtenerFotoPrestador = (prestador?: Prestador | null) => {
  const foto = prestador?.foto;

  if (typeof foto !== "string" || foto.trim() === "") {
    return "";
  }

  const fotoNormalizada = foto.trim();

  if (
    fotoNormalizada.startsWith("data:") ||
    fotoNormalizada.startsWith("http://") ||
    fotoNormalizada.startsWith("https://")
  ) {
    return fotoNormalizada;
  }

  const mimeType = inferirMimeTypeImagenBase64(fotoNormalizada);
  return `data:${mimeType};base64,${fotoNormalizada}`;
};
